import { useRef, FC, memo, useMemo } from 'react';
import { Image } from '@chakra-ui/react';

// Force bundler to resolve to a URL string
import defaultUniLogoSrc from '../../../../assets/images/fallback_uni_logo.png?url';
import { getUniLogoSrc } from './getUniLogoSrc';
import enrolyLogo from '../../../../assets/images/uni_logo.svg?url';
// import enrolyLogo from '../../../../assets/images/uni_logo.svg';

type Props = {
  className?: string;
  alt?: string;
  assetsUrl?: string;
  isStudentApp?: boolean;
};

export const UniLogo: FC<Props> = memo(({ className, alt, assetsUrl, isStudentApp }) => {
  const imgRef = useRef<HTMLImageElement>(null);

  const handleOnError = () => {
    if (imgRef.current) {
      imgRef.current.src = defaultUniLogoSrc;
    }
  };

  const uniLogoSrc = useMemo(
    () => (isStudentApp && assetsUrl && getUniLogoSrc(assetsUrl) ? getUniLogoSrc(assetsUrl) : enrolyLogo),
    [isStudentApp],
  );

  return (
    <>
      {isStudentApp ? (
        <Image
          height="6rem"
          objectFit="contain"
          className={className}
          ref={imgRef}
          src={uniLogoSrc}
          alt={alt ?? 'Enroly logo'}
          onError={handleOnError}
        />
      ) : (
        <Image src={uniLogoSrc} alt="Enroly logo" height={16} />
      )}
    </>
  );
});
